module.exports = __webpack_public_path__ + "img/32.d3b1d933.jpg";